/* eslint-disable eslint-comments/disable-enable-pair -- needed */
/* eslint-disable react/no-unescaped-entities -- needed */
/* eslint-disable no-else-return -- needed */
import {
  Selectors,
  Utils,
  generateUrls,
} from '@americanexpress/axp-benefits-utils';
import PerformanceMeasure from '@americanexpress/browser-performance-mark';
import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';
import {
  CARD_PRODUCT,
  getProductDetailsById,
  getProductRegistryById,
  getProductsByTypes,
  getSelectedProduct,
} from '@americanexpress/product-ducks';
import { withReactlytics } from '@americanexpress/reactlytics';
import { RenderModule } from 'holocron';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  IconAirplane,
  IconBusiness,
  IconCard,
  IconCardBenefit,
  IconConcierge,
  IconDining,
  IconDollarCashback,
  IconEntertainment,
  IconLounge,
  IconMerchandise,
  IconRewards,
  IconTravelBag,
} from '@americanexpress/dls-icons';
import {
  Accordion,
  AccordionContent,
  AccordionPanel,
  Heading,
  Layout,
  Surface,
} from '@americanexpress/dls-react';
import { fromJS } from 'immutable';
import { allBenefits, benefitHighlights } from '../../../constants';
import { TermsLinks } from '../../shared/components/terms-links';
import {
  getSpecialTiles,
  getTileLayout,
  isMobileLoggedInUser,
  renderViewAllTitle,
  setProductSelected,
  formatCategoryName,
} from '../utils';

import AnalyticsClick from '../../shared/components/analyticsClick';
import Error from '../../shared/components/error';
import { Loading } from '../../shared/components/loading';
import styles from '../styles/viewall.css';
import { BenefitsHeading } from './BenefitsHeading';
import { CardBanner } from './CardBanner';
import Disclaimer from './Disclaimer';
import FilterContainer from './FilterContainer';
import GridController from './GridController';
import GridControllerSansCatalog from './GridControllerSansCatalog';
import SearchBox from './searchBox/searchBox';
import TermsModal from './TermsModal';

export class NewViewAllPage extends Component {
  constructor(props) {
    super(props);
    const initialToggleState = new Array(10).fill('open');
    const mobileToggleState = new Array(10).fill('open');
    initialToggleState[0] = 'close';
    // Set initial category from props.initialCategory if present
    this.state = {
      filteredBenefits: null,
      category: props.initialCategory || null,
      isListView: false,
      searchFilter: '',
      searchData: '',
      searching: false,
      isDisclaimerVisible: false,
      isHighlightsVisible: false,
      isAllBenefitsVisible: false,
      accordianState: initialToggleState && initialToggleState,
      mobileAccordianState: mobileToggleState && mobileToggleState,
      pendingScrollCategory: null,
    };
    this.showMobileTileView = this.showMobileTileView.bind(this);
    this.updateBenefitsFilter = this.updateBenefitsFilter.bind(this);
    this.updateUiView = this.updateUiView.bind(this);
    this.newSearch = this.newSearch.bind(this);
    this.toggleAccordian = this.toggleAccordian.bind(this);
  }

  componentDidMount() {
    document.body.style.overflow = 'auto';
    window.addEventListener('scroll', this.handleScroll);
    this?.handleScroll();

    // Store category param for scroll after render
    const categoryParam = new URLSearchParams(window.location.search).get('category');
    if (categoryParam) {
      this.setState({ pendingScrollCategory: categoryParam });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // Auto-scroll AccordionPanel header to top on page load/category change
    // This logic waits for the AccordionPanel header and its content to be fully rendered and stable.
    // It then scrolls the header to the top of the viewport, just below its own height.
    // The scroll only happens once per page load/category change.
    // retryCount and MAX_RETRIES prevent infinite loops if the DOM never reaches the expected state.
    const { pendingScrollCategory } = this.state;
    const cardProduct = this.props?.readLoyaltyBenefits?.cardProduct;
    const newFilteredName = cardProduct?.productLayout?.filters;
    const remove = ['categories', 'category', 'filteredBenefits'];
    const validCategories = newFilteredName != null
      ? Object.keys(newFilteredName).filter((key) => !remove.includes(key))
      : [];
    if (pendingScrollCategory && validCategories.length > 0) {
      const idx = validCategories.findIndex(
        (cat) => formatCategoryName(cat) === formatCategoryName(pendingScrollCategory)
      );
      if (idx !== -1) {
        // Delay scroll to next tick to ensure Accordion content is rendered
        setTimeout(() => {
          this.waitAndScroll(idx);
        }, 0);
      }
    }

    let cardname = this.props?.cardname?.data?.cardname || 'undefined';
    let previousCardname = prevProps.cardname?.data?.cardname || 'undefined';
    const {
      isDisclaimerVisible,
      isHighlightsVisible,
      isAllBenefitsVisible,
      searchFilter,
    } = this.state;
    let noSearchFilter = prevState.searchFilter !== '' && searchFilter === '';
    const shouldImpressionFire = {
      disclaimer: isDisclaimerVisible && !prevState.isDisclaimerVisible,
      highlights: isHighlightsVisible && !prevState.isHighlightsVisible,
      'all-benefits': isAllBenefitsVisible && !prevState.isAllBenefitsVisible,
    };

    if (noSearchFilter || previousCardname !== cardname) {
      this.setState({
        filteredBenefits:
          this.props.readLoyaltyBenefits?.cardProduct?.benefitsOrderList,
        category: 'All',
      });
    }

    if (
      prevProps?.readLoyaltyBenefits?.cardProduct?.benefitsOrderList
      !== this.props.readLoyaltyBenefits?.cardProduct?.benefitsOrderList
    ) {
      this.setState({
        filteredBenefits:
          this.props.readLoyaltyBenefits?.cardProduct?.benefitsOrderList,
      });
    }

    Object.entries(shouldImpressionFire).forEach(([key, value]) => {
      if (value) {
        this.impressionFire(key, 'impression');
      }
    });
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  isComponentVisible = (compDiv) => {
    const rect = compDiv?.getBoundingClientRect();
    const isVisible = rect?.top >= 0
      && rect?.left >= 0
      && rect?.bottom
      <= (window.innerHeight || document.documentElement.clientHeight)
      && rect?.right
      <= (window.innerWidth || document.documentElement.clientWidth);
    return isVisible;
  };

  handleScroll = () => {
    const discDiv = document.querySelector('#benefits-disclaimer');
    const highlightsDivCatEnroll = document.querySelector('#highlightsDiv');
    const highlightsDivCat = document.querySelector('#highlightsDivCatalog');
    const highlightsDiv = highlightsDivCatEnroll || highlightsDivCat;
    const allBenefitsDivCatEnroll = document.querySelector('#allBenefitsDiv');
    const allBenefitsDivCat = document.querySelector('#allBenefitsDivCat');
    const allBenefitsDiv = allBenefitsDivCatEnroll || allBenefitsDivCat;

    if (discDiv) {
      this.setState({ isDisclaimerVisible: this.isComponentVisible(discDiv) });
    }
    if (highlightsDiv) {
      this.setState({
        isHighlightsVisible: this.isComponentVisible(highlightsDiv),
      });
    }
    if (allBenefitsDiv) {
      this.setState({
        isAllBenefitsVisible: this.isComponentVisible(allBenefitsDiv),
      });
    }
  };

  handleSearchCatalog = (e) => {
    if (e.target.value.length <= 0) {
      this.setState({
        searchFilter: '',
        searching: false,
        searchData: '',
      });
    } else {
      this.setState({
        searchData: e.target.value,
      });
    }
  };

  handleClearSearch = () => {
    this.setState({
      searchData: '',
      searching: false,
      searchFilter: '',
    });
  }

  handleClick = () => {
    if (this.state.searchData?.length > 1) {
      this.setState({
        searchFilter: this.state.searchData,
        searching: true,
      });
      this.impressionFire('search-results', 'impression');
    } else {
      this.setState({
        searchFilter: '',
        searching: false,
      });
    }
  };

  showMobileTileView = () => {
    if (global.BROWSER) {
      window.scrollTo(0, 0);
    }
  }

  /**
   * Private method to handle scroll-to-header logic for AccordionPanel.
   * Used in componentDidUpdate. Exposed for unit testing.
   * @param {number} idx - Index of the category header to scroll to
   * @param {function} [onScroll] - Optional callback for test verification
   */
  waitAndScroll(idx, onScroll) {
    let lastHeaderTop = null;
    let stableCount = 0;
    let retryCount = 0;
    const MAX_RETRIES = 100;
    const scrollFn = () => {
      const header = document.querySelector(`#header-collapsible-p-h${idx}`);
      const content = document.querySelector(`[aria-labelledby='header-collapsible-p-h${idx}']`);
      const contentReady = content && content.offsetHeight > 100 && content.children.length > 0;
      if (!header || !contentReady) {
        if (retryCount < MAX_RETRIES) {
          retryCount += 1;
          requestAnimationFrame(scrollFn);
        }
        return;
      }
      const offset = header.offsetHeight ?? 0;
      const rect = header.getBoundingClientRect();
      if (lastHeaderTop !== null && Math.abs(rect.top - lastHeaderTop) < 2) {
        stableCount += 1;
        if (stableCount > 7) {
          window.scrollTo({
            top: window.scrollY + rect.top - offset,
            behavior: 'auto',
          });
          if (typeof onScroll === 'function') onScroll();
          this.setState({ pendingScrollCategory: null });
          return;
        }
      } else {
        stableCount = 0;
      }
      lastHeaderTop = rect.top;
      if (retryCount < MAX_RETRIES) {
        retryCount += 1;
        requestAnimationFrame(scrollFn);
      }
    };
    scrollFn();
  }

  impressionFire(msg, tp) {
    let analytics = this.props?.analytics;
    let track = analytics?.track;
    let cardname = this.props?.cardname?.data?.cardname || 'undefined';
    if (typeof track === 'function') {
      setTimeout(() => {
        track({ event: { element: `${cardname}>>${msg}`, type: tp } });
      },
      500);
    }
  }

  updateBenefitsFilter(newList, cat) {
    this.props.readLoyaltyBenefits.cardProduct.productLayout.filters.category = cat;
    if (cat === 'All') {
      this.props.readLoyaltyBenefits.cardProduct.productLayout.filters.filteredBenefits = this.props.readLoyaltyBenefits.cardProduct.benefitsOrderList;
      this.setState({
        filteredBenefits:
          this.props.readLoyaltyBenefits.cardProduct.productLayout.filters
            .filteredBenefits,
        category: cat,
      });
    } else {
      this.props.readLoyaltyBenefits.cardProduct.productLayout.filters.filteredBenefits = newList;
      this.setState({
        filteredBenefits: newList,
        category: cat,
      });
    }
  }

  // Toggle value for list and grid view
  updateUiView(value) {
    const NEW_LIST_VIEW_STATE = typeof value === 'boolean' ? value : !this.state.isListView;
    this.setState({ isListView: NEW_LIST_VIEW_STATE });
  }

  newSearch() {
    document?.getElementById('df-search')?.focus();
    this.setState({
      searchFilter: '',
      searching: false,
      searchData: '',
    });
  }

  toggleAccordian(idx, ctgr, mobileView) {
    this.setState((prevState) => {
      const newToggleState = [...prevState.accordianState];
      const newMobileToggleState = [...prevState.mobileAccordianState];
      newToggleState[idx] = newToggleState[idx] === 'open' ? 'close' : 'open';
      if (mobileView) {
        newMobileToggleState[idx] = newMobileToggleState[idx] === 'open' ? 'close' : 'open';
      }
      return {
        accordianState: newToggleState,
        mobileAccordianState: newMobileToggleState,
      };
    });
    if (mobileView) {
      this.impressionFire(
        `accordion-${this.state.mobileAccordianState[idx]}>>${formatCategoryName(ctgr)}`,
        'click'
      );
    } else {
      this.impressionFire(
        `accordion-${this.state.accordianState[idx]}>>${formatCategoryName(ctgr)}`,
        'click'
      );
    }
  }

  // eslint-disable-next-line complexity -- needed
  render() {
    const loadingReadLoyaltyBenefits = this.props.loadingReadLoyaltyBenefits;
    const readLoyaltyBenefitsError = this.props.readLoyaltyBenefitsError;
    const readLoyaltyBenefits = this.props?.readLoyaltyBenefits;
    const cardProduct = readLoyaltyBenefits?.cardProduct;
    const cardname = this.props?.cardname?.data?.cardname;
    let searchValue = [];

    if (loadingReadLoyaltyBenefits) {
      return <Loading />;
    }
    if (readLoyaltyBenefitsError) {
      return (<Error locale={this.props.locale} />);
    }

    const {
      login, env, mobileView,
    } = this.props;

    const benefits = readLoyaltyBenefits?.benefits;
    const allBenefitNames = cardProduct?.benefitsOrderList; // list of hyphenated benefit names
    const filteredBenefitNames = this.state.filteredBenefits && this.state.filteredBenefits.length > 0
      ? this.state.filteredBenefits
      : undefined;
    const filteredBenefitOrderList = allBenefitNames?.filter((item) => filteredBenefitNames?.includes(item)
    );
    const benefitNamesToUse = filteredBenefitOrderList?.length > 0
      ? filteredBenefitOrderList
      : allBenefitNames;
    const catalogFilters = cardProduct?.productLayout?.filters;

    const catalogTiles = benefitNamesToUse?.length > 12
      ? benefitNamesToUse?.slice(0, 12)
      : benefitNamesToUse;

    const mobile = isMobileLoggedInUser(this.props.location);
    const isLoggedIn = login || !!mobile;
    const showMRNav = cardProduct?.showMRNav === 'true' && login;

    const searchBenefit = (obj, searchKey, results = []) => {
      let r = results;
      let benefitTextCopy;
      if (obj) {
        Object.keys(obj).forEach((key) => {
          const value = obj[key];
          if (key === searchKey && typeof value !== 'object') {
            r.push(value);
          } else if (typeof value === 'object') {
            benefitTextCopy = {
              value: value?.benefitName,
              copy: value?.summary?.marketingText?.copy,
              benefitTitle: value?.benefitTitle,
              detailsCopy: value?.details?.marketingText?.copy,
            };
            r.push(benefitTextCopy);
          }
        });
      }
      return r;
    };
    const searchList = searchBenefit(benefits, 'benefitName');

    const stripHtml = (htmlString) => {
      const div = document.createElement('div');
      div.innerHTML = htmlString;

      div.querySelectorAll('li').forEach((liEl) => {
        const textNode = document.createTextNode(' ');
        liEl.appendChild(textNode);
      });
      const text = div.textContent || '';
      return text.replace(/\s+/g, ' ').trim();
    };

    const searchFilterData = searchList.filter((option) => {
      const copy = option.copy;
      const value = option.value;
      const detailsCopy = stripHtml(option.detailsCopy);
      const benefitTitle = option.benefitTitle.toLowerCase();
      const searchFilter = this.state.searchFilter.toLowerCase();

      if (searchFilter.length > 2 && (value.includes(searchFilter) || detailsCopy.toLowerCase().includes(searchFilter) || copy.includes(searchFilter))) {
        searchValue.push(option.value);
      }
      if (searchFilter.length > 2 && benefitTitle.includes(searchFilter)) {
        searchValue.push(option.value);
      } else if (searchFilter.length > 2 && (!option.copy.includes(searchFilter) && !detailsCopy.toLowerCase().includes(searchFilter))) {
        return null;
      }
      return searchValue;
    });

    const searchFilterValue = searchFilterData?.map((data) => {
      return data.value;
    });

    const filteredBenefitTiles = allBenefitNames
      && allBenefitNames.filter((item) => searchFilterValue?.includes(item));
    const newFilteredName = cardProduct?.productLayout?.filters;

    const accordianCategories = {};
    if (newFilteredName != null) {
      // eslint-disable-next-line no-restricted-syntax -- needed
      for (const key of Object.keys(newFilteredName)) {
        if (Array.isArray(newFilteredName[key])) {
          const sortedArray = newFilteredName
            && newFilteredName[key].sort((a, b) => {
              return (
                // eslint-disable-next-line no-unsafe-optional-chaining -- reuited
                filteredBenefitTiles?.indexOf(a)
                // eslint-disable-next-line no-unsafe-optional-chaining -- reuited
                - filteredBenefitTiles?.indexOf(b)
              );
            });
          accordianCategories[key] = sortedArray;
        }
      }
    }

    // Supported locales for new view-all experience
    const supportedLocales = [
      'en-US',
      'es-MX',
      'en-CA',
      'ja-JP',
      'en-AU',
      'en-GB',
      'fr-CA',
      'en-NZ',
      'en-HK',
      'zh-HK',
      'fr-FR',
      // 'en-XA',
      // 'en-XB',
    ];

    const icons = {
      Travel: <IconAirplane size="md" />,
      'Premium Travel': <IconTravelBag size="md" />,
      Entertainment: <IconEntertainment size="md" />,
      Shopping: <IconMerchandise size="md" />,
      Services: <IconConcierge size="md" />,
      'Membership Rewards': <IconRewards size="md" />,
      Enroll: <IconCard size="md" />,
      'Cash Back': <IconDollarCashback size="md" />,
      Rewards: <IconRewards size="md" />,
      Dining: <IconDining size="md" />,
      'Business Tools': <IconBusiness size="md" />,
      Access: <IconLounge size="md" />,
      Default: <IconCardBenefit size="md" />,
    };

    const getAccordianId = (idx) => {
      return `collapsible-p-h${idx}`;
    };

    const getCategoryFromAccordianId = (id) => {
      const match = id.match(/-cat-(.+)$/);
      return match ? match[1] : null;
    };
    const remove = ['categories', 'category', 'filteredBenefits'];
    const validCategories = newFilteredName != null
      ? Object.keys(newFilteredName).filter((key) => !remove.includes(key))
      : '';

    // only render tracker module when the user is viewing a card product that they have
    const renderTracker = Boolean(this.props?.productType === 'CARD_PRODUCT')
      && !this.props?.fromParams;

    // Set url param for selected card or banking product
    let productSelected = '';
    if (isLoggedIn) {
      productSelected = setProductSelected(this?.props?.productRegistry);
    }

    let VIEW_ALL_LOGIN = '';
    if (global.BROWSER) {
      VIEW_ALL_LOGIN = encodeURIComponent(
        `${window?.location?.origin}/card-benefits/view-all`
      );
    }

    let defaultOpenPanelId = 'collapsible-p-h0';
    if (this.state.category && validCategories) {
      const idx = validCategories.findIndex(
        (cat) => formatCategoryName(cat) === formatCategoryName(this.state.category)
      );
      if (idx !== -1) {
        defaultOpenPanelId = `collapsible-p-h${idx}`;
      }
    }

    if (supportedLocales.includes(this?.props?.locale)) {
      return (
        <div className={styles.newViewAllContainer}>
          {showMRNav && (
            <div className="margin-1-b">
              <RenderModule
                moduleName="axp-global-rewards-nav"
                props={{
                  location: this.props.location,
                  router: this.props.router,
                }}
              />
            </div>
          )}
          <div className="margin-center pad-0-r">
            {login && (
              <BenefitsHeading
                locale={this.props.locale}
                accKey={this.props.selectedProduct.account_key}
                cardname={cardname}
              />
            )}
          </div>
          {renderTracker && this.props.locale === 'en-US' && (
            <RenderModule
              moduleName="axp-benefits-trackers"
              props={{
                mode: 'best',
                headerText: (
                  <FormattedMessage
                    id="view-all.tracker.heading"
                    defaultMessage="Benefits Activity"
                  />
                ),
                cardname: `${cardname}`,
                vortexEnabled: false,
              }}
            />
          )}
          <div>
            {renderViewAllTitle(cardProduct?.productLayout?.pageTitle, this.props.locale)}
          </div>
          <div className={`margin-center pad-0-r ${styles.termsWidth} margin-2-b`}>
            {!login && (
              <CardBanner
                cardImageURL={cardProduct?.marketingText?.imageUrl}
                properCardName={cardProduct?.productLayout?.productTitle}
                heroDesc={cardProduct?.productLayout?.introductoryText}
                loginUrl={generateUrls(env).MYCA_LOGIN_URL + VIEW_ALL_LOGIN}
              />
            )}
          </div>
          <Layout innerContainerClassName="pad-2-l pad-2-t pad-3-l-lg-up pad-3-t-lg-up pad-r-0 pad-0-b" className="margin-2-tb margin-3-tb-lg-up">
            <Heading id="highlightsDivCatalog" level={2} variant="sans-medium-bold" className="color-subtle-text margin-1-b">
              {benefitHighlights}
            </Heading>
            <div className="margin-2-b">
              <TermsLinks
                cardname={cardname}
                localeDetails={this.props.locale}
              />
            </div>
            <AnalyticsClick element={`${cardname}>>search>>enter-text`}>
              <SearchBox
                autoFocus=""
                buttonSearch={true}
                id="df-search"
                onChange={(e) => this.handleSearchCatalog(e)}
                onSearch={this.handleClick}
                onClearSearch={this.handleClearSearch}
                searchButtonProps={{
                  reactlytics: {
                    element: `${formatCategoryName(cardname)}>>search>>run`,
                  },
                }}
                value={this.state.searchData}
                clearButtonProps={{
                  reactlytics: {
                    element: `${formatCategoryName(cardname)}>>search>>clear-text`,
                  },
                }}
                reactlytics={{ disable: true }}
              />
            </AnalyticsClick>
            <div className={`margin-2-t margin-3-t-lg-up ${this.state.searching === true ? 'margin-2-b margin-3-b-lg-up margin-2-r margin-3-r-lg-up' : ''}`}>
              {this.state.searching === true && (
                <div>
                  <Heading level={4} variant="sans-xsmall-regular" className="margin-2-b" role="presentation">
                    <FormattedMessage
                      id="view-all.catalog.showing"
                      defaultMessage="Showing"
                    />
                    {filteredBenefitTiles.length}
                    <FormattedMessage
                      id="view-all.catalog.results"
                      defaultMessage=" results for "
                    />
                    "{this.state.searchData}"
                  </Heading>
                </div>
              )}
              <GridController
                benefitNames={
                  this.state.searchFilter.length <= 2
                    ? catalogTiles
                    : filteredBenefitTiles
                }
                benefits={benefits}
                login={isLoggedIn}
                membership={this.props.membership}
                cardname={cardname}
                specialTiles={getSpecialTiles(benefits)}
                longTiles={getTileLayout(
                  cardProduct?.benefitsOrderList,
                  cardProduct?.benefitsOrderList,
                  login
                )}
                fromParams={this.props.fromParams}
                productSelected={productSelected}
                mobileView={false}
                showMobileTileView={this.showMobileTileView}
                searchFilter={this.state.searchFilter}
                newSearch={this.newSearch}
                category={this.state.category}
                isListView={this.state.searching === true}
                isHorizontalTile={false}
                catalogFilters={catalogFilters}
                analyticsTag={this.state.analyticsTag}
                searching={this.state.searching}
              />
            </div>
          </Layout>
          {this.state.searching === false ? (
            <Layout innerContainerClassName="pad-2 pad-3-lg-up">
              <div>
                <Heading
                  level={2}
                  variant="sans-medium-bold"
                  id="allBenefitsDivCat"
                  className="pad-2-b pad-3-b-lg-up"
                >
                  {allBenefits} (
                  {benefits != null ? Object.keys(benefits).length : '0'})
                </Heading>

                {mobileView ? (
                  <Accordion
                    defaultOpenPanelIds={(() => {
                      if (this.state.category && validCategories) {
                        const idx = validCategories.findIndex(
                          (cat) => formatCategoryName(cat) === formatCategoryName(this.state.category)
                        );
                        if (idx !== -1) {
                          return [`collapsible-p-h${idx}`];
                        }
                      }
                      return [''];
                    })()}
                    onAccordionToggle={(e, idx) => this.toggleAccordian(idx, getCategoryFromAccordianId(idx), mobileView)}
                  >
                    {validCategories
                      && validCategories?.map((category, index) => {
                        return (
                          <>
                            <AccordionPanel
                              icon={icons[category]}
                              id={getAccordianId(index)}
                              data-category={category}
                              heading={(
                                <Heading level={3} variant="sans-xsmall-bold">
                                  <FormattedMessage
                                    id={`view-all.category.${formatCategoryName(category)}`}
                                    defaultMessage={category}
                                  />
                                  ({newFilteredName[category]?.length})
                                </Heading>
                              )}
                            />
                            <AccordionContent
                              aria-labelledby={getAccordianId(index)}
                              className="pad-0"
                            >
                              <Surface variant="base" className="pad-2-lr pad-3-lr-lg-up pad-2-t pad-3-t-lg-up">
                                <GridController
                                  benefitNames={accordianCategories[category]}
                                  benefits={benefits}
                                  login={isLoggedIn}
                                  membership={this.props.membership}
                                  cardname={cardname}
                                  specialTiles={getSpecialTiles(benefits)}
                                  longTiles={getTileLayout(
                                    cardProduct?.benefitsOrderList,
                                    cardProduct?.benefitsOrderList,
                                    login
                                  )}
                                  fromParams={this.props.fromParams}
                                  productSelected={productSelected}
                                  mobileView={false}
                                  showMobileTileView={this.showMobileTileView}
                                  searchFilter={this.state.searchFilter}
                                  newSearch={this.newSearch}
                                  category={category}
                                  isListView={true}
                                  isHorizontalTile={true}
                                  analyticsTag={this.state.analyticsTag}
                                />
                              </Surface>
                            </AccordionContent>
                          </>
                        );
                      })}
                  </Accordion>
                ) : (
                  <Accordion
                    defaultOpenPanelIds={[defaultOpenPanelId]}
                    onAccordionToggle={(e, idx) => {
                      this.toggleAccordian(idx, getCategoryFromAccordianId(idx), mobileView);
                    }}
                  >
                    {validCategories
                      && validCategories?.map((category, index) => {
                        return (
                          <>
                            <AccordionPanel
                              icon={icons[category]}
                              id={getAccordianId(index)}
                              heading={(
                                <Heading level={3} variant="sans-xsmall-bold">
                                  <FormattedMessage
                                    id={`view-all.category.${formatCategoryName(category)}`}
                                    defaultMessage={category}
                                  />
                                  ({newFilteredName[category]?.length})
                                </Heading>
                              )}
                            />
                            <AccordionContent
                              aria-labelledby={getAccordianId(index)}
                              className="pad-0"
                            >
                              <Surface variant="base" className="pad-2-t pad-3-t-lg-up pad-2-lr pad-3-lr-lg-up">
                                <GridController
                                  benefitNames={newFilteredName[category]}
                                  benefits={benefits}
                                  login={isLoggedIn}
                                  membership={this.props.membership}
                                  cardname={cardname}
                                  specialTiles={getSpecialTiles(benefits)}
                                  longTiles={getTileLayout(
                                    cardProduct?.benefitsOrderList,
                                    cardProduct?.benefitsOrderList,
                                    login
                                  )}
                                  fromParams={this.props.fromParams}
                                  productSelected={productSelected}
                                  mobileView={false}
                                  showMobileTileView={this.showMobileTileView}
                                  searchFilter={this.state.searchFilter}
                                  newSearch={this.newSearch}
                                  category={category}
                                  isListView={true}
                                  isHorizontalTile={true}
                                  analyticsTag={this.state.analyticsTag}
                                />
                              </Surface>
                            </AccordionContent>
                          </>
                        );
                      })}
                  </Accordion>
                )}
              </div>
            </Layout>
          ) : null}
          <Layout
            id="benefits-disclaimer"
            innerContainerClassName="pad-2 pad-3-lg"
            className="flex flex-column flex-justify-center text-nowrap margin-0-lr margin-1-b margin-2-t margin-3-t-lg-up"
          >
            <Disclaimer />
          </Layout>
          <PerformanceMeasure
            moduleName="axp-benefits-view-all"
            variable={true}
          />
        </div>
      );
    } else {
      return (
        <>
          <div className={styles.newViewAllContainer}>
            {showMRNav && (
              <div className="margin-1-b">
                <RenderModule
                  moduleName="axp-global-rewards-nav"
                  props={{
                    location: this.props.location,
                    router: this.props.router,
                  }}
                />
              </div>
            )}
            <div className="margin-center pad-0-r">
              {login && (
                <BenefitsHeading
                  locale={this.props.locale}
                  accKey={this.props.selectedProduct.account_key}
                  cardname={cardname}
                />
              )}
            </div>
            {renderTracker
              && this.props.rblbt !== 'true'
              && this.props.locale === 'en-US' && (
                <RenderModule
                  moduleName="axp-benefits-trackers"
                  props={{
                    mode: 'best',
                    headerText: (
                      <FormattedMessage
                        id="view-all.tracker.heading"
                        defaultMessage="Benefits Activity"
                      />
                    ),
                    cardname: `${cardname}`,
                    vortexEnabled: false,
                  }}
                />
            )}
            <div>
              {renderViewAllTitle(cardProduct?.productLayout?.pageTitle, this.props.locale)}
            </div>
            <div className={`margin-center pad-0-r ${styles.termsWidth}`}>
              {!login && (
                <CardBanner
                  cardImageURL={cardProduct?.marketingText?.imageUrl}
                  properCardName={cardProduct?.productLayout?.productTitle}
                  heroDesc={cardProduct?.productLayout?.introductoryText}
                  loginUrl={generateUrls(env).MYCA_LOGIN_URL + VIEW_ALL_LOGIN}
                />
              )}
            </div>
            <div
              style={{ display: 'flow-root', justifyContent: 'center' }}
              className="flex flex-wrap"
            >
              {this.props.enabled !== 'true'
                && this.props.locale === 'en-US' ? (
                  <>
                    <FilterContainer
                      benefits={filteredBenefitNames}
                      cardname={cardname}
                      location={this.props.location}
                      login={isLoggedIn}
                      env={env}
                      accountKey={this.props.selectedProduct.account_key}
                      filters={cardProduct?.productLayout?.filters}
                      updateBenefitsFilter={this.updateBenefitsFilter}
                      isCardUsingOneData={true} // // TODO: needed for list view. Remove once list view goes away
                      isListView={this.state.isListView}
                      updateUiView={this.updateUiView}
                      searchFilter={this.state.searchFilter}
                      searchFilterData={searchFilterValue}
                      searchExperience={true}
                      handleSearch={this.handleSearch}
                      analytics={this.props?.analytics}
                    />
                    <div
                      className={`card card-rounded pad-responsive stack flex flex-column flex-justify-center text-nowrap margin-0-lr margin-1-b ${styles.termsWidth}`}
                    >
                      <TermsModal
                        cardname={cardname}
                        fromParams={this.props.fromParams}
                        location={this.props.location}
                        localeDetails={this.props.locale}
                      />
                    </div>
                  </>
                )
                : ''}
            </div>
            <GridControllerSansCatalog
              benefitNames={
                this.state.searchFilter.length <= 2
                  ? benefitNamesToUse
                  : filteredBenefitTiles
              }
              benefits={benefits}
              login={isLoggedIn}
              membership={this.props.membership}
              cardname={cardname}
              specialTiles={getSpecialTiles(benefits)}
              longTiles={getTileLayout(
                cardProduct?.benefitsOrderList,
                cardProduct?.benefitsOrderList,
                login
              )}
              fromParams={this.props.fromParams}
              productSelected={productSelected}
              mobileView={false}
              showMobileTileView={this.showMobileTileView}
              searchFilter={this.state.searchFilter}
              newSearch={this.newSearch}
              category={this.state.category}
              isListView={this.state.isListView}
              analyticsTag={this.state.analyticsTag}
            />
          </div>
          <Layout
            id="benefits-disclaimer"
            innerContainerClassName="pad-2 pad-3-lg"
            className="flex flex-column flex-justify-center text-nowrap margin-0-lr margin-1-b margin-2-t margin-3-t-lg-up"
          >
            <Disclaimer />
          </Layout>
          <PerformanceMeasure
            moduleName="axp-benefits-view-all"
            variable={true}
          />
        </>
      );
    }
  }
}

NewViewAllPage.propTypes = {
  mobileView: PropTypes.bool,
  readLoyaltyBenefits: PropTypes.shape({
    cardProduct: PropTypes.shape({
      marketingText: PropTypes.shape({
        copy: PropTypes.string,
        imageUrl: PropTypes.string,
      }),
      productLayout: PropTypes.shape({
        pageTitle: PropTypes.string,
        productTitle: PropTypes.string,
        filters: PropTypes.shape({
          filteredBenefits: PropTypes.arrayOf(PropTypes.string),
          category: PropTypes.string,
        }),
      }),
      benefitsOrderList: PropTypes.arrayOf(PropTypes.string),
    }),
    benefits: PropTypes.shape({
      legacyBenefitId: PropTypes.string,
      benefitName: PropTypes.string,
      benefitTitle: PropTypes.string,
      details: PropTypes.shape({
        layout: PropTypes.shape({
          webFormat: PropTypes.string,
        }),
      }),
    }),
  }),
  login: PropTypes.bool,
  env: PropTypes.string,
  fromParams: PropTypes.bool,
  membership: PropTypes.string,
  location: PropTypes.shape({
    query: PropTypes.shape({}),
  }).isRequired,
  router: PropTypes.shape({}),
  selectedProduct: PropTypes.shape({
    account_key: PropTypes.string,
  }),
  languageData: PropTypes.shape({}),
};

NewViewAllPage.defaultProps = {
  login: false,
  env: 'production',
  membership: '',
  mobileView: null,
  selectedProduct: '',
  fromParams: false,
};

export function mapStateToProps(state, ownProperties) {
  const product = getSelectedProduct(state);
  const products = getProductsByTypes(state, [CARD_PRODUCT]);
  return {
    login: Boolean(product),
    cardname:
      Selectors.getCardNameFromParams(state, ownProperties)
      || Selectors.getCardNameFromState(state),
    env: Selectors.getEnv(state),
    membership:
      products?.[CARD_PRODUCT]?.productsList?.[product]?.account
        ?.relationship || null,
    selectedProduct: getProductDetailsById(state, product),
    productType: getProductRegistryById(state, product)?.type,
    productRegistry: getProductRegistryById(state, product),
    locale: fromJS(state).getIn(['intl', 'activeLocale']),
  };
}

const hocChain = compose(
  withReactlytics(oneAppModuleWrapper('axp-benefits-view-all')),
  connect(mapStateToProps, null)
);

export default hocChain(Utils.MobileRender(NewViewAllPage, 430));
